module.exports = require("froala-editor/js/plugins.pkgd.min.js");